// Copyright (c) 2019 Deere & Company

import './app-header.scss';
import AppGreeting from './app-greeting';
import AppLogo from './app-logo';
import AppNavigation from './app-navigation';
import AuthenticatedPage from '../authenticated-page';
import React from 'react';
import { withRouter } from 'react-router-dom';
// import PropTypes from 'prop-types';
// import { getFactories } from '../../repositories';

// function handleNavigationToHomePage () {
//     this.actions.navigateToHomePage(this.history);
// }

const AppHeader = () => (
    <div>
        <div className="app-header">
            <div className="confidential-logo-group">
                <AppLogo />
            </div>
            <div className="app-title-section">
                <div className="title-and-greeting">
                    <h1 className="app-title">
                        {/*<div onClick={handleNavigationToHomePage}>*/}
                        {`Warranty Warehouse 
                        ${process.env.REACT_APP_ENVIRONMENT === 'PROD' ? '' 
                            : ` - ${process.env.REACT_APP_ENVIRONMENT}`}`
                        }
                        {/*</div>*/}
                    </h1>
                    <AppGreeting />
                </div>
            </div>
        </div>
        <AuthenticatedPage>
            <AppNavigation />
        </AuthenticatedPage>
    </div>
);

// AppHeader.displayName = 'AppHeader';
// AppHeader.propTypes = {
//     environment: PropTypes.string.isRequired,
// };
export default withRouter( AppHeader );
